import styled from 'styled-components';

import { Card } from '@zillow/constellation';

export const StyledCard = styled(Card)`
  height: 150px;
  cursor: pointer;
`;
